import React, { useState, useEffect, useRef } from "react";
import ScrollArea from "react-scrollbars-custom";
import classNames from "classnames";
import { compose } from "redux";

import connectProps from "fantastic/lib/connectProps";
import connectActions from "fantastic/lib/connectActions";
import getSelected from "fantastic/selectors/getSelected";
import sectionsOperations from "fantastic/lib/sections";
import actions from "fantastic/actions";
import settings from "./settings";

import Breadcrumbs from "./Breadcrumbs";

const RightSidebar = props => {
  const scrollRef = useRef(null);

  const scrollToIfNeeded = element => {
    scrollRef.current.scrollTo(0, element.offsetTop);
  };

  const handleSuccess = event => {
    props.select(null);
  };

  const handleTrash = event => {
    props.trash(props.selected);
  };

  const getSelectedNode = () => {
    const { selected, sections } = props;
    return sectionsOperations.byId(selected, sections);
  };

  const selectedKind = () => {
    const selectedNode = getSelectedNode();
    if (selectedNode && !selectedNode.kind) return selectedNode.meta.type;
    return selectedNode.kind;
  };

  const { selected } = props;
  if (!selected) return null;

  const selectedNode = getSelectedNode();
  if (!selectedNode) return null;

  const sidebarClasses = classNames(
    "fantastic-sidebar fantastic-sidebar--right"
  );
  const Type =
    settings[
      selectedKind()
        .toLowerCase()
        .replace(/\w/, c => c.toUpperCase()) + "Settings"
    ];
  return (
    <div className={sidebarClasses}>
      <div className="fantastic-sidebar__wrapper">
        <div className="fantastic-sidebar__header">
          <div className="fantastic-sidebar__caption">
            {selectedNode.meta.name}
          </div>
          <a
            className="btn btn-default fantastic-sidebar__close"
            onClick={handleSuccess}
          >
            <i className="fa fa-remove" />
          </a>
        </div>
        <Breadcrumbs />
        <div className="fantastic-sidebar__body">
          <ScrollArea noDefaultStyles={true} ref={scrollRef}>
            <div className="fantastic-sidebar__scroll-area">
              {Type ? (
                <Type
                  {...props}
                  selectedNode={selectedNode}
                  scrollToIfNeeded={scrollToIfNeeded}
                />
              ) : (
                <div>TODO #{selectedNode.kind || selectedNode.meta.type}</div>
              )}
            </div>
          </ScrollArea>
        </div>
        <div className="fantastic-sidebar__actions">
          <button className="btn btn-success-inverse" onClick={handleSuccess}>
            { i18n.t('finish') }
          </button>
          {selectedNode.meta.removable && (
            <button className="btn btn-remove" onClick={handleTrash}></button>
          )}
        </div>
      </div>
    </div>
  );
};

export default compose(
  connectProps({ selected: getSelected }, "sections"),
  connectActions({
    update: actions.updateNode,
    select: actions.setSelected,
    trash: actions.removeId
  })
)(RightSidebar);
